import { useMutation, useQueryClient } from '@tanstack/react-query'
import { API_ROUTES } from '@/constants/routes'
import { api } from '@/lib/axios'

interface UpdatePagePayload {
    projectId: string
    pageId: number
    canvas_json: Record<string, unknown>
}

interface CreatePagePayload {
    projectId: string
    page_number: number
}

export function useUpdatePage() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async ({ projectId, pageId, canvas_json }: UpdatePagePayload) => {
            const { data } = await api.patch(
                API_ROUTES.projectPage(projectId, pageId),
                { canvas_json }
            )
            return data
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['projects', 'detail', variables.projectId] })
        },
    })
}

export function useCreatePage() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async ({ projectId, page_number }: CreatePagePayload) => {
            const { data } = await api.post(API_ROUTES.projectPages(projectId), { page_number })
            return data
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['projects', 'detail', variables.projectId] })
        },
    })
}

export function useDeletePage() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async ({ projectId, pageId }: { projectId: string; pageId: number }) => {
            await api.delete(API_ROUTES.projectPage(projectId, pageId))
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['projects', 'detail', variables.projectId] })
        },
    })
}
